import React, {ButtonHTMLAttributes, FC} from 'react';
import {Button} from "@src/@/components/ui/button";


type Props = ButtonHTMLAttributes<HTMLButtonElement>
const PrimaryButton: FC<Props> = (props) => <Button variant={'primary'} {...props} />

export default PrimaryButton;
